import { getDivisions } from '@api/getDivisions';
import { useEffect, useState } from 'react';
import { useCustomParams } from './useCustomParams';

export type DivisionType = {
  division: string;
  id: number | string;
};

interface useDivisionsType {
  divisionList: DivisionType[];
  isLoading: boolean;
}

export const useDivisions = (): useDivisionsType => {
  const [divisionList, setDivisionList] = useState<DivisionType[]>([]);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { searchParams } = useCustomParams();
  const election_schedule_id = searchParams.get('election_schedule_id');

  useEffect(() => {
    setIsLoading(true);
    if (election_schedule_id) {
      getDivisions(election_schedule_id)
        .then((data) => {
          setDivisionList(data?.data || []);
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
        });
    } else {
      setIsLoading(false);
    }
  }, [election_schedule_id]);

  return {
    divisionList,
    isLoading,
  };
};
